export default "__VITE_ASSET__Jz3URN80__"